export default __webpack_public_path__ + "static/media/pa3.33748950.png";